export default {

    roundByEight(result) {
        return (Math.round((result) * 8) / 8).toFixed(3);
    },

    weight(initialWeight, initialUom, convertToUom) {

        const grams = this.convertToGrams(initialWeight, initialUom)

        const result = this.convertFromGrams(grams, convertToUom)

        return result > 0 ? result : null // closes 0.125 : null

    },

    volume(initialVolume, initialUom, convertToUom) {

        const grams = this.convertToTeaspoons(initialVolume, initialUom)

        const result = this.convertFromTeaspoons(grams, convertToUom)

        return result > 0 ? result : null // closes 0.125 : null

    },

    custom(initialWeight, initialUom, convertToUom, convertUomAmt) {

        return initialWeight / convertUomAmt;

        const grams = this.convertToGrams(initialWeight, initialUom);

        const result = this.customConvertFromGrams(grams, convertToUom, convertUomAmt)

        return result > 0 ? result : null // closes 0.125 : null

    },

    customConvertFromGrams(initialWeight, convertToUom, convertUomAmt) {

        if (convertToUom === 'Gram') {
            return initialWeight;
        }
        if (convertToUom === 'Ounce') {
            return initialWeight / 28.34952;
        }
        if (convertToUom === 'Pound' || convertToUom === 'LB') {
            return initialWeight / 453.59237;
        }


        if (convertToUom === 'Kilogram' || convertToUom === 'KGM') {
            return initialWeight / 1000;
        }

        if (convertToUom === 'Milligram' || convertToUom === 'MGM') {
            return initialWeight / 0.001;
        }

        // custom
        return initialWeight / convertUomAmt;

        // error
        return -1;
    },

    volumeToWeight(preferredProduct, recipeAmount, recipeUom, newUom, cuoms = []) {
        let nutrition_facts_volume_uom = preferredProduct.nutrition_facts_volume_uom;
        let nutrition_facts_volume = preferredProduct.nutrition_facts_volume;
        let nutrition_facts_weight = preferredProduct.nutrition_facts_weight;
        let nutrition_facts_weight_uom = preferredProduct.nutrition_facts_weight_uom;

        // if(nutrition_facts_volume <= 0 &&  cuoms && cuoms.length > 0)
        // {
        for (let i = 0; i < cuoms.length; i++) {
            console.log("conversion volumeToWeight loop ", cuoms[i], this.uomType(cuoms[i].unit_type));
            if (this.uomType(cuoms[i].unit_type) === 'Volume') {
                console.log("conversion volumeToWeight", cuoms[i]);
                nutrition_facts_volume_uom = cuoms[i].unit_type;
                nutrition_facts_volume = cuoms[i].unit_amount;
                nutrition_facts_weight = cuoms[i].weight;
                nutrition_facts_weight_uom = cuoms[i].weight_units;
            }
        }
        // }

        // Convert Recipe Amount / UOM to preferred UOM
        let baseRecipeAmount = this.volume(recipeAmount, recipeUom, nutrition_facts_volume_uom);

        // Convert preferred Weight UOM to preferred Volume UOM
        // let scale = nutrition_facts_volume / nutrition_facts_weight;
        let scale = nutrition_facts_weight / nutrition_facts_volume;

        console.log("Conversions ", scale, nutrition_facts_volume, nutrition_facts_weight);

        // Convert to final volume UOM
        baseRecipeAmount = baseRecipeAmount * scale;

        let result = this.weight(baseRecipeAmount, nutrition_facts_weight_uom, newUom);

        return result

    },

    weightToVolume(preferredProduct, recipeAmount, recipeUom, newUom, cuoms = []) {
        // console.log('weightToVolume preferredProduct', preferredProduct)
        let nutrition_facts_volume_uom = preferredProduct.nutrition_facts_volume_uom;
        let nutrition_facts_volume = preferredProduct.nutrition_facts_volume;
        let nutrition_facts_weight = preferredProduct.nutrition_facts_weight;
        let nutrition_facts_weight_uom = preferredProduct.nutrition_facts_weight_uom;

        if (cuoms && cuoms.length > 0) {
            for (let i = 0; i < cuoms.length; i++) {
                if (this.uomType(cuoms[i].unit_type) === 'Volume') {
                    console.log("conversion weightToVolume", cuoms[i]);
                    nutrition_facts_volume_uom = cuoms[i].unit_type;
                    nutrition_facts_volume = cuoms[i].unit_amount;
                    nutrition_facts_weight = cuoms[i].weight;
                    nutrition_facts_weight_uom = cuoms[i].weight_units;
                }
            }
        }



        // console.log("weightToVolume nutrition", nutrition_facts_volume_uom, nutrition_facts_volume, nutrition_facts_weight, nutrition_facts_weight_uom);
        // console.log("weightToVolume Conversions", recipeAmount, recipeUom, nutrition_facts_weight_uom);
        // Convert Recipe Amount / UOM to preferred UOM
        let baseRecipeAmount = this.weight(recipeAmount, recipeUom, nutrition_facts_weight_uom);
        // console.log("weightToVolume baseRecipeAmount", baseRecipeAmount);
        // Convert preferred Weight UOM to preferred Volume UOM
        // let scale = nutrition_facts_weight / nutrition_facts_volume;
        let scale = nutrition_facts_volume / nutrition_facts_weight;

        // Convert to final volume UOM
        baseRecipeAmount = baseRecipeAmount * scale;
        // console.log("weightToVolume scale", scale);
        // console.log("weightToVolume baseRecipeAmount", baseRecipeAmount);

        let result = this.volume(baseRecipeAmount, nutrition_facts_volume_uom, newUom);
        // console.log("weightToVolume result", result);

        return result;

    },

    volumeToUnit(preferredProduct, recipeAmount, recipeUom, newUom, cuoms = []) {
        let nutrition_facts_volume_uom = preferredProduct.nutrition_facts_volume_uom;
        let nutrition_facts_volume = preferredProduct.nutrition_facts_volume;
        let nutrition_facts_unit = preferredProduct.nutrition_facts_unit;
        let nutrition_facts_unit_uom = preferredProduct.nutrition_facts_unit_uom;

        // if(nutrition_facts_volume <= 0 &&  cuoms && cuoms.length > 0)
        // {
        // for (let i = 0; i < cuoms.length; i++) {
        //     console.log("conversion volumeToWeight loop ", cuoms[i], this.uomType(cuoms[i].unit_type));
        //     if (this.uomType(cuoms[i].unit_type) === 'Volume') {
        //         console.log("conversion volumeToWeight", cuoms[i]);
        //         nutrition_facts_volume_uom = cuoms[i].unit_type;
        //         nutrition_facts_volume = cuoms[i].unit_amount;
        //         nutrition_facts_weight = cuoms[i].weight;
        //         nutrition_facts_weight_uom = cuoms[i].weight_units;
        //     }
        // }
        // }

        // Convert Recipe Amount / UOM to preferred UOM
        let baseRecipeAmount = this.volume(recipeAmount, recipeUom, nutrition_facts_volume_uom);

        // Convert preferred Weight UOM to preferred Volume UOM
        // let scale = nutrition_facts_volume / nutrition_facts_weight;
        let scale = nutrition_facts_unit / nutrition_facts_volume;

        console.log("Conversions ", scale, nutrition_facts_volume, nutrition_facts_unit);

        // Convert to final volume UOM
        baseRecipeAmount = baseRecipeAmount * scale;

        let result = baseRecipeAmount;
        return result

    },
    unitToVolume(preferredProduct, recipeAmount, recipeUom, newUom, cuoms = []) {
        // console.log('weightToVolume preferredProduct', preferredProduct)
        let nutrition_facts_volume_uom = preferredProduct.nutrition_facts_volume_uom;
        let nutrition_facts_volume = preferredProduct.nutrition_facts_volume;
        let nutrition_facts_unit = preferredProduct.nutrition_facts_unit;
        let nutrition_facts_unit_uom = preferredProduct.nutrition_facts_unit_uom;

        // if (cuoms && cuoms.length > 0) {
        //     for (let i = 0; i < cuoms.length; i++) {
        //         if (this.uomType(cuoms[i].unit_type) === 'Volume') {
        //             console.log("conversion weightToVolume", cuoms[i]);
        //             nutrition_facts_volume_uom = cuoms[i].unit_type;
        //             nutrition_facts_volume = cuoms[i].unit_amount;
        //             nutrition_facts_weight = cuoms[i].weight;
        //             nutrition_facts_weight_uom = cuoms[i].weight_units;
        //         }
        //     }
        // }
        // Convert Recipe Amount / UOM to preferred UOM
        let baseRecipeAmount = recipeAmount;
        let scale = nutrition_facts_volume / nutrition_facts_unit;

        // Convert to final volume UOM
        baseRecipeAmount = baseRecipeAmount * scale;

        let result = this.volume(baseRecipeAmount, nutrition_facts_volume_uom, newUom);

        return result;

    },

    weightToUnit(preferredProduct, recipeAmount, recipeUom, newUom, cuoms = []) {
        // console.log('weightToVolume preferredProduct', preferredProduct)
        let nutrition_facts_unit_uom = preferredProduct.nutrition_facts_unit_uom;
        let nutrition_facts_unit = preferredProduct.nutrition_facts_unit;
        let nutrition_facts_weight = preferredProduct.nutrition_facts_weight;
        let nutrition_facts_weight_uom = preferredProduct.nutrition_facts_weight_uom;

        if (cuoms && cuoms.length > 0) {
            for (let i = 0; i < cuoms.length; i++) {
                if (this.uomType(cuoms[i].unit_type) === 'Unit') {
                    console.log("conversion weightToVolume", cuoms[i]);
                    nutrition_facts_unit_uom = cuoms[i].unit_type;
                    nutrition_facts_unit = cuoms[i].unit_amount;
                    nutrition_facts_weight = cuoms[i].weight;
                    nutrition_facts_weight_uom = cuoms[i].weight_units;
                }
            }
        }// Convert Recipe Amount / UOM to preferred UOM
        let baseRecipeAmount = this.weight(recipeAmount, recipeUom, nutrition_facts_weight_uom);
        let scale = nutrition_facts_unit / nutrition_facts_weight;
        // Convert to final volume UOM
        baseRecipeAmount = baseRecipeAmount * scale;
        let result = baseRecipeAmount;
        return result;
    },
    unitToWeight(preferredProduct, recipeAmount, recipeUom, newUom, cuoms = []) {
        let nutrition_facts_unit_uom = preferredProduct.nutrition_facts_unit_uom;
        let nutrition_facts_unit = preferredProduct.nutrition_facts_unit;
        let nutrition_facts_weight = preferredProduct.nutrition_facts_weight;
        let nutrition_facts_weight_uom = preferredProduct.nutrition_facts_weight_uom;

        // if(nutrition_facts_volume <= 0 &&  cuoms && cuoms.length > 0)
        // {
        for (let i = 0; i < cuoms.length; i++) {
            if (this.uomType(cuoms[i].unit_type) === 'Unit') {
                console.log("conversion volumeToWeight", cuoms[i]);
                nutrition_facts_unit_uom = cuoms[i].unit_type;
                nutrition_facts_unit = cuoms[i].unit_amount;
                nutrition_facts_weight = cuoms[i].weight;
                nutrition_facts_weight_uom = cuoms[i].weight_units;
            }
        }
        // }

        // Convert Recipe Amount / UOM to preferred UOM
        let baseRecipeAmount = recipeAmount;

        // Convert preferred Weight UOM to preferred Volume UOM
        // let scale = nutrition_facts_volume / nutrition_facts_weight;
        let scale = nutrition_facts_weight / nutrition_facts_unit;

        console.log("Conversions ", scale, nutrition_facts_weight, nutrition_facts_unit);

        // Convert to final volume UOM
        baseRecipeAmount = baseRecipeAmount * scale;

        let result = this.weight(baseRecipeAmount, nutrition_facts_weight_uom, newUom);

        return result

    },

    convertToGrams(initialWeight, initialUom) {

        if (initialUom === 'Gram') {
            return initialWeight;
        }
        if (initialUom === 'Ounce') {
            return initialWeight * 28.34952;
        }
        if (initialUom === 'Pound' || initialUom === 'LB') {
            return initialWeight * 453.59237;
        }

        if (initialUom === 'Kilogram' || initialUom === 'KGM') {
            return initialWeight * 1000;
        }

        if (initialUom === 'Milligram' || initialUom === 'MGM') {
            return initialWeight * 0.001;
        }

        // error
        return -1;
    },
    convertFromGrams(initialWeight, convertToUom) {

        if (convertToUom === 'Gram') {
            return initialWeight;
        }
        if (convertToUom === 'Ounce') {
            return initialWeight / 28.34952;
        }
        if (convertToUom === 'Pound' || convertToUom === 'LB') {
            return initialWeight / 453.59237;
        }

        if (convertToUom === 'Kilogram' || convertToUom === 'KGM') {
            return initialWeight / 1000;
        }

        if (convertToUom === 'Milligram' || convertToUom === 'MGM') {
            return initialWeight / 0.001;
        }

        // error
        return -1;
    },

    convertToTeaspoons(initialVolume, initialUom) {

        if (initialUom === 'Gallon') {
            return initialVolume * 768
        }
        if (initialUom === 'Quart') {
            return initialVolume * 192;
        }
        if (initialUom === 'Pint') {
            return initialVolume * 96;
        }
        if (initialUom === 'Cup') {
            return initialVolume * 48
        }
        if (initialUom === 'Fluid Ounce') {
            return initialVolume * 6
        }
        if (initialUom === 'Tablespoon') {
            return initialVolume * 3;
        }

        if (initialUom === 'Litre') {
            return initialVolume * 202.884;
        }

        if (initialUom === 'Millilitre') {
            return initialVolume * 0.202884;
        }

        if (initialUom === 'Teaspoon') {
            return initialVolume * 1;
        }



        // error
        return -1;
    },
    convertFromTeaspoons(initialVolume, convertToUom) {

        if (convertToUom === 'Gallon') {
            return initialVolume / 768
        }
        if (convertToUom === 'Quart') {
            return initialVolume / 192;
        }
        if (convertToUom === 'Pint') {
            return initialVolume / 96;
        }
        if (convertToUom === 'Cup') {
            return initialVolume / 48
        }
        if (convertToUom === 'Fluid Ounce') {
            return initialVolume / 6
        }
        if (convertToUom === 'Tablespoon') {
            return initialVolume / 3;
        }

        if (convertToUom === 'Litre') {
            return initialVolume / 202.884;
        }

        if (convertToUom === 'Millilitre') {
            return initialVolume / 0.202884;
        }

        if (convertToUom === 'Teaspoon') {
            return initialVolume / 1;
        }

        // error
        return -1;
    },

    uomType(val) {
        const weight = [
            'Ounce',
            'Gram',
            'LB',
            'Kilogram',
            'Milligram',
        ];

        const volume = [
            'Gallon',
            'Quart',
            'Pint',
            'Cup',
            'Fluid Ounce',
            'Tablespoon',
            'Teaspoon',
            'Litre',
            'Millilitre',
        ];

        const unit = [
            'Each',
            'Count',
            'Piece',
        ];

        if (unit.includes(val)) {
            return "Unit"
        }
        if (volume.includes(val)) {
            return "Volume"
        }
        if (weight.includes(val)) {
            return "Weight"
        }

        if (val != '') {
            return "Custom";
        }

        return "Not Found"
    }
};
